import { render, staticRenderFns } from "./MassiveImportInfoUserModal.vue?vue&type=template&id=2b00de87&scoped=true&"
import script from "./MassiveImportInfoUserModal.vue?vue&type=script&lang=js&"
export * from "./MassiveImportInfoUserModal.vue?vue&type=script&lang=js&"
import style0 from "./MassiveImportInfoUserModal.vue?vue&type=style&index=0&id=2b00de87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b00de87",
  null
  
)

export default component.exports